import { h, render } from 'preact';
import ShopTheLookDropdown from './shop-the-look-dropdown';

export default (element, data) => {
  const init = () => {
    render(<ShopTheLookDropdown {...data} />, element);
  };

  init();
};
